<div class="initial-view" *ngIf="GlobalSettingsService.isGlobalLoaderLoading">
	<div class="container">
		<img src="../assets/images/Vitralogy_Logo_Blue.png" />
		<div class="horizontal-loader"></div>
	</div>
</div>

<app-loader *ngIf="GlobalSettingsService.isSecondaryLoaderLoading"></app-loader>

<div class="menu-container" *ngIf="GlobalSettingsService.isGlobalHeadingVisible">
	<app-navigation-bar></app-navigation-bar>
</div>

<div class="page-container">
	<router-outlet></router-outlet>
</div>

<div class="toast-container">
	<ng-container *ngFor="let toast of ToastService.toasts">
		<toast *ngIf="toast.isVisible" [toast]="toast" (click)="toast.isVisible = false" @fadeIn @fadeOut></toast>
	</ng-container>
</div>